import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import moment from "moment";
import { useQueryClient } from "@tanstack/react-query";

export default function Timer({
  textColor,
  time,
  onExpire,
  setShowReleaseBtn,
  acctId,
  className,
  classNameTitle,
  classNameClock,
  ShowTitle = true,
  type = "",
  createdAt
}: {
  textColor?: string;
  time: string;
  onExpire?: () => void;
  setShowReleaseBtn?: any | undefined;
  acctId: string;
  className?: any;
  classNameTitle?: any;
  classNameClock?: any;
  ShowTitle?: boolean;
  type?: string;
  createdAt: string;
}) {
  const targetTime = moment.utc(time).valueOf();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const queryClient = useQueryClient();
  const [hasEnded, setHasEnded] = useState(false);

  function calculateTimeLeft() {
    const difference = targetTime - moment().utc().valueOf();
    if (difference <= 0) {
      return { days: "00", hours: "00", minutes: "00" };
    }
    const totalHours = Math.floor(difference / (1000 * 60 * 60));

    const days = String(Math.floor(totalHours / 24)).padStart(2, "0");
    const hours = String(Math.floor(totalHours % 24)).padStart(2, "0");
    const minutes = String(
      Math.floor((difference / (1000 * 60)) % 60)
    ).padStart(2, "0");

    return { days, hours, minutes };
  }
  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      const isZero =
        newTimeLeft.days === "00" &&
        newTimeLeft.hours === "00" &&
        newTimeLeft.minutes === "00";
      if (
        -moment.utc(createdAt).diff(moment().utc(), "minutes") <=
        +`${process.env.REACT_APP_RELEASE_TIMER}`
          ? true
          : false
      ) {
        setShowReleaseBtn &&
          setShowReleaseBtn(
            -moment.utc(createdAt).diff(moment().utc(), "minutes") <=
              +`${process.env.REACT_APP_RELEASE_TIMER}`
              ? true
              : false
          );
      }
      if (isZero && !hasEnded) {
        setHasEnded(true);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (hasEnded && onExpire) {
      // Store previous data for rollback if needed
      const previousInvList = queryClient.getQueryData(["inv-list"]);
      const previousVaults = queryClient.getQueryData(["flipper-vaults"]);

      // Optimistically update inv-list
      queryClient.setQueryData(["inv-list"], (oldData: any) => {
        if (!oldData) return oldData;
        return oldData.map((item: any) => ({
          ...item,
          accounts: item.accounts?.map((account: any) => {
            if (account?.checkoutId === acctId) {
              return {
                ...account,
                releasedAt: moment().utc().toISOString(),
                email: null,
                plainPhone: null
              };
            }
            return account;
          })
        }));
      });

      // Optimistically update flipper-vaults
      queryClient.setQueryData(["flipper-vaults"], (oldData: any) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map((page: any) => ({
            ...page,
            accounts: page?.accounts?.map((account: any) => {
              if (account?.acctId === acctId) {
                return {
                  ...account,
                  contacts: null
                };
              }
              return account;
            })
          }))
        };
      });

      // Call onExpire callback
      try {
        onExpire();
        // After successful expiration, invalidate queries to get fresh data
        Promise.all([
          queryClient.invalidateQueries({ queryKey: ["inv-list"] }),
          queryClient.invalidateQueries({ queryKey: ["flipper-vaults"] })
        ]);
      } catch (error) {
        // If there's an error, rollback to previous state
        queryClient.setQueryData(["inv-list"], previousInvList);
        queryClient.setQueryData(["flipper-vaults"], previousVaults);
        console.error("Error handling timer expiration:", error);
      }
    }
  }, [hasEnded, onExpire, acctId, queryClient]);

  return (
    <div
      className={`${styles.FlipperVaultCardTimer} ${
        textColor ? styles[textColor] : ""
      } ${className}`}
    >
      {ShowTitle && (
        <div
          className={`${styles.FlipperVaultCardTimerTitle} ${classNameTitle}`}
        >
          Time Remaining
        </div>
      )}
      <div className={`${styles.FlipperVaultCardTimerValue} ${classNameClock}`}>
        {timeLeft.days} : {timeLeft.hours} : {timeLeft.minutes}
      </div>
      <div className={styles.FlipperVaultCardTimerLabel}>
        <span>Days</span>
        <span>Hrs</span>
        <span>Min</span>
      </div>
    </div>
  );
}
